// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/_css-loader@0.28.7@css-loader/index.js?minimize!../../node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4d16a0fc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./Icons.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/_vue-style-loader@3.0.3@vue-style-loader/lib/addStylesClient.js")("f023a9b2", content, true);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-style-loader@3.0.3@vue-style-loader!./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d16a0fc","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/demos/Icons.vue
// module id = mv2g
// module chunks = 1